export default function FeatureRequestForm() {
  return (
    <div className="flex flex-col justify-start items-center h-full w-full">
      <iframe
        className="airtable-embed bg-transparent "
        src="https://airtable.com/embed/shrdH7lIeTLisJ09A?backgroundColor=blue"
        width="100%"
        height="900"
        title="feature-request"
      ></iframe>
    </div>
  );
}
